export default ":host .kt-subheader__desc {\n  margin: 0;\n}"